import { Facebook, Twitter, Linkedin, Github } from 'lucide-react';

export function Footer() {
  const links = {
    solutions: [
      { name: '跨境物流', href: '#business' },
      { name: '电子商务', href: '#business' },
      { name: '智慧健康', href: '#business' },
    ],
    company: [
      { name: '关于我们', href: '#about' },
      { name: '技术实力', href: '#technology' },
      { name: '发展历程', href: '#history' },
    ],
    support: [
      { name: '联系我们', href: '#contact' },
      { name: '服务支持', href: '#contact' },
      { name: '合作伙伴', href: '#' },
    ],
  };
  const logo = '/images/logo.png';

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-orange-900 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 sm:space-x-3 mb-4">
              <img src={logo} alt="越亘科技" className="h-8 sm:h-10 w-auto" />
              <div>
                <div className="text-white text-sm sm:text-base">越亘科技</div>
                <div className="text-xs text-yellow-400">YUEGEEN TECHNOLOGY</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              智慧驱动 共创未来
              <br />
              专注于企业数字化转型与全球化服务
            </p>
            <div className="flex space-x-4">
              {[Facebook, Twitter, Linkedin, Github].map((Icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-8 h-8 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white mb-4">解决方案</h4>
            <ul className="space-y-2">
              {links.solutions.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-400 hover:text-yellow-400 text-sm transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white mb-4">公司信息</h4>
            <ul className="space-y-2">
              {links.company.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-400 hover:text-yellow-400 text-sm transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white mb-4">服务支持</h4>
            <ul className="space-y-2">
              {links.support.map((link, index) => (
                <li key={index}>
                  <a href={link.href} className="text-gray-400 hover:text-yellow-400 text-sm transition-colors">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2014-2025 越亘科技（YUEGEEN TECHNOLOGY）. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                服务条款
              </a>
              <a href="#" className="text-gray-400 hover:text-yellow-400 transition-colors">
                网站地图
              </a>
            </div>
          </div>
		  <div className="text-gray-400 text-sm mt-4">
			<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">越亘科技官网    渝ICP备14000574号-5</a>
		  </div>
        </div>
      </div>
    </footer>
  );
}